import React from 'react'
import styled from 'styled-components'

const StyledForm = styled.form`
    width: 100%;
`

const FormGroup = styled.div`
    margin-bottom: 1rem;
`

const FormRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;

    & > [class*='col-'],
    & > div {
        padding-right: 5px;
        padding-left: 5px;
    }
`

const Form = ({ children, ...props }) => {
    return <StyledForm {...props}>{children}</StyledForm>
}

Form.Group = FormGroup
Form.Row = FormRow

export default Form
